export enum EAdmins {
  GET_LIST = 'admins/getAdmins',
  ADD_ADMIN = 'admins/addNewAdmin',
  EDIT_ADMIN = 'admins/editAdmin',
  SEND_INVITE = 'admins/sendInvite',
  DELETE_ADMIN = 'admins/deleteAdmin',
}
